import React,{useState} from "react";
import {snackbarContext} from '../helpers/Snakbar'
import { useDispatch, useSelector } from "react-redux";
import { clearError, sendEmailOTP } from "../../redux/reducers/authSlice";
import { useNavigate } from "react-router-dom";

const TrialEmail = ({onContinue,onBack,theme,utm}) => {
  const navigate=useNavigate()
  const setStateSnackbarContext=React.useContext(snackbarContext)
  const dispatch=useDispatch()
  const [values,setValues]=useState({
    email:"",
    name: ""
  })

  

      const handleChange=(event)=>{
    setValues({
        ...values,
        [event.target.name]: event.target.value
      });    
}

const handleSubmit=()=>{

   // 1. Trim whitespace
    const name = values.name.trim();
    const email = values.email.trim();

     if (!name) {
      return setStateSnackbarContext(
        true,
        "Please enter your name",
        "warning"
      );
    }

     if (name.length < 2) {
      return setStateSnackbarContext(
        true,
        "Please enter a valid name",
        "error"
      );
    }

    if (name.length > 50) {
      return setStateSnackbarContext(
        true,
        "Name cannot be more than 50 characters",
        "error"
      );
    }

   // 2. Required validation
    if (!email) {
      return setStateSnackbarContext(
        true,
        "Please enter your email",
        "warning"
      );
    }

      // 3. Basic email format validation
    const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    if (!validEmailRegex.test(email)) {
      return setStateSnackbarContext(
        true,
        "Please enter a valid email address",
        "error"
      );
    }

    // 4. Normalize for consistency
    const normalizedEmail = email.toLowerCase();

    // dispatching the action 
    dispatch(sendEmailOTP({email:normalizedEmail,name,setStateSnackbarContext,onContinue, isResend: false, navigate,theme,utm}))


}


  return (
    <div className="trial-card">

      <img
        src="/wordmarklogo.png"
        alt="Aamantran"
        className="trial-logo"
      />

      <h2 className="trial-card-heading">
        Start Your Free Trial
      </h2>

      <p className="trial-helper-text">
        (3-day free trial to explore the invite,
        <br />
        Upgrade anytime to keep it active)
      </p>

      <div className="trial-points">

        <span>
          <span className="trial-check">✓</span>
          No card required
        </span>

        <span>
          <span className="trial-check">✓</span>
          Ready in 5 minutes
        </span>

      </div>


      <div className="trial-email-section">

  <label className="trial-input-label">
          Your name <span style={{ color: "red" }}> *</span>
        </label>
         
         <input
          type="text"
          name="name"
          value={values.name}
          onChange={handleChange}
          placeholder="Enter your name"
          className="trial-email-input"
        />

        <label className="trial-input-label trial-email-label">
          Email address <span style={{ color: "red" }}> *</span>
        </label>

        <input
          type="email"
          name="email"
          value={values.email}
          onChange={handleChange}
          placeholder="Enter your email"
          className="trial-email-input"
        />

        <button
          className="trial-continue-button"
          onClick={handleSubmit}
        >
          Continue
        </button>

        <button
          className="trial-back-button"
          onClick={onBack}
        >
          ← Back to other options
        </button>

      </div>

    </div>
  );
};

export default TrialEmail;